class Controller {
  constructor(Sections, Events, $stateParams, TopupsTransforms) {
    "ngInject";

    this.Events = Events;
    this.$stateParams = $stateParams;
    this.TopupsTransforms = TopupsTransforms;
    this.fields = this.TopupsTransforms.fields;
    this.filters = this.TopupsTransforms.filters;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.activeParams = this.$stateParams;
    this.sections = Sections.settingsSections;
    this.sortEvent = Events.getSortEvent("topups");
    this.paginateEvent = Events.getPaginateEvent("topups");
    this.filterEvent = Events.getFilterEvent("topups");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/topups/topups.controller.js